import { createHashRouter, redirect } from 'react-router-dom';
import { ErrorBoundary } from 'src/modules/common/components/ErrorBoundary/ErrorBoundary';
import { SensorsPage } from 'src/sensors/list/SensorsPage.tsx';
import { SensorAccessoriesPage } from 'src/sensors/accessories/SensorsAccessoriesPage.tsx';
import { BELIMO_HASH_PREFIX } from 'src/BELIMO_HASH_PREFIX.ts';
import { PrefetchSensorsCheckout } from 'src/sensors/checkout/PrefetchSensorsCheckout.tsx';

export enum PATHS {
    Home = `${BELIMO_HASH_PREFIX}/`,
    Sensors = `${BELIMO_HASH_PREFIX}/sensors`,
    SensorsFilter = `${BELIMO_HASH_PREFIX}/sensors-filter`,
    Accessories = `${BELIMO_HASH_PREFIX}/accessories`,
    Checkout = `${BELIMO_HASH_PREFIX}/checkout`,
}

const errorElement = <ErrorBoundary/>;

export const router = () => createHashRouter([
    {
        path: `${PATHS.Sensors}/:page`,
        element: <SensorsPage/>,
        errorElement,
    },
    {
        path: `${PATHS.Accessories}/:sensorLabel/:page`,
        element: <SensorAccessoriesPage/>,
        errorElement,
    },
    {
        path: `${PATHS.Checkout}/:sensorLabel/:page`,
        element: <PrefetchSensorsCheckout/>,
        errorElement,
    },
    {
        path: '*',
        loader: () => redirect(`${PATHS.Sensors}/1`),
        errorElement,
    },
]);
